import { Observable } from 'rxjs';

import {
  CoverageDecisionPayload,
  CoverageRequestDetail,
  CoverageResponse,
  CoverageRule,
  CoverageSettings,
  CoverageSettingsPayload,
  CreateCoverageRequestPayload,
  DeleteCoverageRuleResponse,
  GetCoverageParams,
  ListCoverageRequestsParams,
  ListCoverageRequestsResponse,
  SaveCoverageRulePayload,
} from '../../../interfaces/coverage.interface';

/** Único punto de acceso a datos de cobertura (`/quotes/coverage`). Clase abstracta: es el token de inyección. */
export abstract class CoverageApiService {
  abstract getSettings(): Observable<CoverageSettings>;

  abstract updateSettings(body: CoverageSettingsPayload): Observable<CoverageSettings>;

  /** Sin parámetros lista estados; cada parámetro baja un nivel. */
  abstract list(params: GetCoverageParams): Observable<CoverageResponse>;

  abstract saveRule(body: SaveCoverageRulePayload): Observable<CoverageRule>;

  abstract deleteRule(id: number, reason: string): Observable<DeleteCoverageRuleResponse>;

  abstract createRequest(body: CreateCoverageRequestPayload): Observable<CoverageRequestDetail>;

  abstract listRequests(
    params: ListCoverageRequestsParams,
  ): Observable<ListCoverageRequestsResponse>;

  abstract getRequest(id: number): Observable<CoverageRequestDetail>;

  abstract decideRequest(
    id: number,
    body: CoverageDecisionPayload,
  ): Observable<CoverageRequestDetail>;
}
